import { render } from "./DecorationPage.vue?vue&type=template&id=a787be1c&scoped=true"
import script from "./DecorationPage.vue?vue&type=script&lang=js"
export * from "./DecorationPage.vue?vue&type=script&lang=js"

import "./DecorationPage.vue?vue&type=style&index=0&id=a787be1c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a787be1c"]])

export default __exports__